import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import { WatchlistListModuleFactory } from '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { WatchlistCreateStoreModuleFactory } from '../watchlist-create/index.module.js';
import { WatchlistEditStoreModuleFactory } from '../watchlist-edit/index.module.js';
import { WatchlistDeleteStoreModuleFactory } from '../watchlist-delete/index.module.js';
import { inheritEndpointOptions, getEndpointOptions } from '../../helpers/common.js';

class WatchlistListStoreModuleFactory extends Mdg2StoreModuleFactory {
  getWatchlistListRequest() {
    return {};
  }
  getWatchlistListData(payload) {
    var _a;
    const request = this.getWatchlistListRequest();
    const response = this.getEndpoints().watchlistList.getData(request);
    return (_a = response == null ? void 0 : response.data) != null ? _a : null;
  }
  getPaginatedWatchlistListData(payload) {
    var _a;
    const watchlistListData = this.getWatchlistListData(payload);
    return (_a = watchlistListData == null ? void 0 : watchlistListData.slice(payload.pageOffset * payload.itemsPerPage, (payload.pageOffset + 1) * payload.itemsPerPage)) != null ? _a : null;
  }
  getResponseItem(payload, watchlist) {
    return {
      id: watchlist.id,
      name: watchlist.name,
      numberOfPositions: watchlist.numberPositions
    };
  }
  getResponseData(payload) {
    var _a, _b;
    return (_b = (_a = this.getPaginatedWatchlistListData(payload)) == null ? void 0 : _a.map((watchlist) => this.getResponseItem(payload, watchlist))) != null ? _b : [];
  }
  getResponseMeta(payload) {
    var _a;
    const watchlistListData = this.getWatchlistListData(payload);
    return {
      pagination: {
        total: (_a = watchlistListData == null ? void 0 : watchlistListData.length) != null ? _a : null
      }
    };
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  async updateWatchlistList(payload) {
    const request = this.getWatchlistListRequest();
    return this.getEndpoints().watchlistList.updateState(request);
  }
  async updateComponentsInputs(payload) {
    let isRequestSuccessful = true;
    try {
      await this.updateWatchlistList(payload);
    } catch (error) {
      this.logger.error(error);
      isRequestSuccessful = false;
    }
    return Promise.resolve(isRequestSuccessful);
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getDependencies() {
    var _a, _b, _c, _d;
    if (!this.dependencies) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      const factoryData = {
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store
      };
      this.dependencies = {
        watchlistCreate: new WatchlistCreateStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_b = this.options) == null ? void 0 : _b.create) }),
        watchlistEdit: new WatchlistEditStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_c = this.options) == null ? void 0 : _c.edit) }),
        watchlistDelete: new WatchlistDeleteStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_d = this.options) == null ? void 0 : _d.delete) })
      };
    }
    return this.dependencies;
  }
  getEndpoints() {
    var _a;
    if (!this.endpoints) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      this.endpoints = {
        watchlistList: this.getModuleEntity(WatchlistListModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistList"))
      };
    }
    return this.endpoints;
  }
}

export { WatchlistListStoreModuleFactory };
